import { render, staticRenderFns } from "./LocationManageDetail.vue?vue&type=template&id=8a27e9e6"
import script from "./LocationManageDetail.vue?vue&type=script&lang=js"
export * from "./LocationManageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports